import React from 'react'
import styled from 'styled-components'

import { useI18n } from '../hooks/use-i18n'
import { usePlayers } from '../hooks/use-players'
import Layout from '../layout'
import PlayerTextInput from '../components/player-text-input'
import ResultsTable from '../components/results-table'

export default function Root() {
  const { t } = useI18n()

  const { players, selectedPlayers, selectPlayer, success } = usePlayers()

  return (
    <Layout>
      <Container>
        {success && <p className="success">{t('root.success-message')}</p>}
        {!success && (
          <>
            <p className="instructions">{t('root.instructions')}</p>
            <PlayerTextInput players={players} selectPlayer={selectPlayer} selectedPlayers={selectedPlayers} />
          </>
        )}
        <div className="results-container">
          {selectedPlayers.length > 0 && <ResultsTable selectedPlayers={selectedPlayers} />}
        </div>
      </Container>
    </Layout>
  )
}

const Container = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 24px;
  height: 100%;
  justify-content: flex-start;
  overflow: auto;
  padding-top: 48px;
  width: 100%;

  & > p {
    padding: 0 24px;
    max-width: 480px;
    text-align: center;
    width: 100%;
  }

  .results-container {
    align-items: flex-start;
    display: flex;
    flex-direction: column;
    overflow: auto;
    justify-content: flex-start;
    width: 100%;
  }
`
